// extracted by mini-css-extract-plugin
module.exports = {"aff_loading":"fCRES","affspin":"Ih8V9"};